<component v-bind:is="getContainerType" v-bind:class="getClassName">
    <table>
        <tr>
            <th v-for="(colHeader, key) in getColHeaders" v-bind:key="key">{{ $t(colHeader) }}</th>
        </tr>
        <tr v-for="(qtyRow,key) in getQuantities" v-bind:key="key"
            v-on:click="getSetQuantityFunction(qtyRow.quantity, qtyRow.code)" v-bind:class="activeClass(qtyRow.active)">
            <td>{{qtyRow.quantity}} {{$t('Pcs')}}</td>
            <td v-if="canDisplayNetPrice()">{{qtyRow.formatted_base_price ? qtyRow.formatted_base_price : $n(qtyRow.base_price, 'currency')}}</td>
            <td v-if="canDisplayGrossPrice()">{{qtyRow.formatted_gross_price ? qtyRow.formatted_gross_price : $n(qtyRow.gross_price, 'currency')}}</td>
        </tr>
    </table>
</component>